enum PUNCHOUT_TYPE {
  oci = 'oci',
  cxml = 'cxml',
}

export {
  PUNCHOUT_TYPE,
};

